// @ts-nocheck
import React, { Component, Suspense } from 'react'
import styled from 'styled-components'
import CodeBox from '../components/CodeBox'
import Sidebar from '../components/Sidebar'
import { findById } from '../constants/constants'
import { components } from '../constants/constants'

export default class ComponentPage extends Component {
  render() {
    const { id: componentId } = this.props.match.params
    const component = findById(componentId)
    const ComponentAPI = component.api

    return (
      <Container>
        <Sidebar selected={componentId} components={components} />
        <Content>
          <section>
            <h2 data-testid="componentTitle">
              {component.name} {component.zhName}
            </h2>
            <p data-testid="componentDescription">{component.description}</p>
          </section>
          <section>
            <h3>代码演示</h3>
            <CodeList>
              {component.demoList.map((item, index) => (
                <CodeBox
                  key={index}
                  component={item.Demo}
                  title={item.title}
                  description={item.description}
                  example={item.example}
                />
              ))}
            </CodeList>
          </section>
          <section>
            <h3>API 接入参数</h3>
            <Suspense fallback={<div>Loading...</div>}>
              <ApiTable data-testid="apiTable">
                <ComponentAPI />
              </ApiTable>
            </Suspense>
          </section>
        </Content>
      </Container>
    )
  }
}

const Container = styled.div`
  display: flex;
  align-items: baseline;
`
const Content = styled.div`
  padding: 20px;
  flex-grow: 2;
`
const CodeList = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const ApiTable = styled.div`
  table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      border: 1px solid black;
    }
    tr th {
      text-align: left;
    }
  }
`
